import axios from '@/base/axios'
import api from './api'

// 设备状态
const getDevice = (params) => {
  return axios.post(api.selectList, params)
}
// 设备大类
const getDeviceBig = (params) => {
  return axios.post(api.deviceBig, params)
}
// 设备信息地图保存
const addDeviceMessageMap = (params) => {
  return axios.post(api.addDeviceMessageMap, params)
}
// 设备信息地图保存查询
const getDeviceMessageMap = (params) => {
  return axios.post(api.getDeviceMessageMap, params)
}
// 设备小类
const getDeviceSmall = (params) => {
  return axios.post(api.deviceSmall, params)
}
// 设备列表
const getDeviceList = (params) => {
  return axios.post(api.deviceList, params)
}
// 设备归属
const getDeviceAscription = (params) => {
  return axios.post(api.deviceAscription, params)
}
// deviceDetails设备详情接口
const getDeviceDetails = (params) => {
  return axios.post(api.deviceDetails, params)
}
// devicePeople设备联系人列表
const devicePeopleList = (params) => {
  return axios.post(api.devicePeople, params)
}
// 设备联系人详情接口
const devicePeopleDetail = (params) => {
  return axios.post(api.devicePeopleDetail, params)
}
// devicePeopleEdit设备联系人编辑接口
const getDevicePeopleEdit = (params) => {
  return axios.post(api.devicePeopleEdit, params)
}
// deviceDeletePeople删除设备联系人
const getDeviceDeletePeople = (params) => {
  return axios.post(api.deviceDeletePeople, params)
}
// deviceListThreshold设备列表 设备类型查询阈值
const getDeviceListThreshold = (params) => {
  return axios.post(api.deviceListThreshold, params)
}
// deviceEdit设备编辑
const getDeviceEdit = (params) => {
  return axios.post(api.deviceEdit, params)
}
// deviceGroupingEdit设备编辑
const getDeviceGroupingEdit = (params) => {
  return axios.post(api.deviceGroupingEdit, params)
}
// 设备分组列表
const getDeviceGroupList = (params) => {
  return axios.post(api.deviceGroupList, params)
}
// deviceGroupDetails设备分组详情接口
const getDeviceGroupDetails = (params) => {
  return axios.post(api.deviceGroupDetails, params)
}
// 设备首页展示类型
const getDeviceShow = (params) => {
  return axios.post(api.deviceListShowHome, params)
}
// 设备首页未展示类型
const getDeviceHide = (params) => {
  return axios.post(api.deviceHideInHome, params)
}
// 设备首页展示移除
const deleteDevice = (params) => {
  return axios.post(api.deleteDeviceShowHome, params)
}
// 设备首页展示类型
const getDevicePosition = (params) => {
  return axios.post(api.devicePosition, params)
}
// 设备类型添加至首页
const addDeviceToHome = (params) => {
  return axios.post(api.addDeviceToHome, params)
}
// 设备类型添加至首页提醒
const addNoHomePageRemind = (params) => {
  return axios.post(api.addNoHomePageRemind, params)
}
// 设备首页展示类型
const saveSortDevice = (params) => {
  return axios.post(api.saveSortDevice, params)
}
// deviceGroupHave设备关联接口
const getDeviceGroupHave = (params) => {
  return axios.post(api.deviceGroupHave, params)
}
// deviceGroupAdd设备分组保存
const deviceGroupAdd = (params) => {
  return axios.post(api.deviceGroupAdd, params)
}
// strategyList 策略管理列表接口
const StrategyList = (params) => {
  return axios.post(api.strategyList, params)
}
// strategyAdd 策略列表新键保存接口
const StrategyAdd = (params) => {
  return axios.post(api.strategyAdd, params)
}
// strategyMaintain策略维护保存接口 => 策略-维护-增加按钮
const StrategyMaintain = (params) => {
  return axios.post(api.strategyMaintain, params)
}
// strategyQuery策略管理维护查询接口
const StrategyQuery = (params) => {
  return axios.post(api.strategyQuery, params)
}
// strategyDatails策略详情接口
const StrategyDatails = (params) => {
  return axios.post(api.strategyDatails, params)
}
// strategyWarningDetails预警详情 接口
const StrategyWarningDetails = (params) => {
  return axios.post(api.strategyWarningDetails, params)
}
// startgyAnd策略关联接口（新的）
const StartgyAnd = (params) => {
  return axios.post(api.startgyAnd, params)
}
// strategyRelationPreservation策略管理与设备关联保存接口
const StrategyRelationPreservation = (params) => {
  return axios.post(api.strategyRelationPreservation, params)
}
// 设备预警类型接口strategyWarning
const StrategyWarningType = (params) => {
  return axios.post(api.strategyWarningType, params)
}
// 预警列表接口 strategyWarningList
const StrategyWarningList = (params) => {
  return axios.post(api.strategyWarningList, params)
}
// getWarnLevelList预警等级
const GetWarnLevelList = (params) => {
  return axios.post(api.getWarnLevelList, params)
}
// strategyWarningListNo预警信息不分页 设备列表编辑tab切换里面使用
const StrategyWarningListNo = (params) => {
  return axios.post(api.strategyWarningListNo, params)
}
// 预警信息导出
const getImportWarnList = (params) => {
  return axios.post(api.getImportWarnList, params)
}
// 新增设备联系人
const devicePeopleAdd = (params) => {
  return axios.post(api.devicePeopleAdd, params)
}
// 告警类型列表
const warnTypeList = (params) => {
  return axios.post(api.warnTypeList, params)
}
// 编辑设备管理
const getEditDevMan = (params) => {
  return axios.post(api.editDevMan, params)
}
// 编辑首页显示设备类型
const editShowDevicd = (params) => {
  return axios.post(api.editShowDevicd, params)
}
// 编辑首页不显示设备类型
const ediHideDevicd = (params) => {
  return axios.post(api.ediHideDevicd, params)
}

const getUserInfoByRoomIdAndUserType = (params) => {
  return axios.post(api.getUserInfoByRoomIdAndUserType, params)
}
const deviceHandle = (params) => {
  return axios.post(api.deviceHandle, params)
}

// 设备导入
const importDevice = (params) => {
  return axios.post(api.importDevice, params)
}

export {
  deviceHandle,
  getDevice,
  getDeviceList,
  getDeviceSmall,
  getDeviceBig,
  addDeviceMessageMap,
  getDeviceMessageMap,
  getDeviceAscription,
  getDeviceDetails,
  getDeviceGroupList,
  getDeviceShow,
  getDeviceHide,
  saveSortDevice,
  deleteDevice,
  addDeviceToHome,
  addNoHomePageRemind,
  getDeviceListThreshold,
  StrategyList,
  StrategyAdd,
  StrategyMaintain,
  StrategyQuery,
  getDeviceEdit,
  getDeviceGroupingEdit,
  StrategyDatails,
  StrategyRelationPreservation,
  StrategyWarningType,
  StrategyWarningList,
  deviceGroupAdd,
  getDeviceGroupHave,
  getDeviceGroupDetails,
  StrategyWarningDetails,
  getDevicePosition,
  StrategyWarningListNo,
  getImportWarnList,
  GetWarnLevelList,
  devicePeopleList,
  getDevicePeopleEdit,
  getDeviceDeletePeople,
  devicePeopleDetail,
  devicePeopleAdd,
  warnTypeList,
  getEditDevMan,
  editShowDevicd,
  ediHideDevicd,
  getUserInfoByRoomIdAndUserType,
  StartgyAnd,
  importDevice
}
